import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import classNames from "classnames";
import getClassNameFactory from "../../../../utilities/classNames";
import ArrowLeftIcon from "@dcl/icons/esm/ui/arrow-left";
var CLASS_NAME = "SiteHeaderPanel";
var ANIMATION_CLOSED = "".concat(CLASS_NAME, "-closed");

var Panel = function Panel(_ref) {
  var children = _ref.children,
      onBack = _ref.onBack,
      open = _ref.open,
      title = _ref.title;
  var getClassName = getClassNameFactory(CLASS_NAME);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isClosed = _useState2[0],
      setClosedState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      prevOpenState = _useState4[0],
      setPrevOpenState = _useState4[1]; // same as `deriveComponentStateFromProps`


  if (prevOpenState !== open) {
    setPrevOpenState(open);
    /**
     * set `isClosed = true` when the panel is not open and isClosed is false
     */

    if (!open && !isClosed) {
      setClosedState(true);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      states: classNames({
        animating: true,
        // animating needs to be true for keyframes to take effect
        closed: isClosed,
        open: open
      })
    }),
    onAnimationEnd: function onAnimationEnd(e) {
      /**
       * we need to set the close state to false to remove the class name
       * otherwise it will re-animate the closed state when open state changes again
       */
      if (e.animationName === ANIMATION_CLOSED) {
        setClosedState(false);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "bar"
    })
  }, /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "backButton"
    }),
    onClick: onBack
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    width: 16
  })), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "barTitle"
    })
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, children));
};

export default Panel;